module.exports = __webpack_public_path__ + "media/images/point/btn-b548b15e85b49b949baf1012e596eaea.png";